export default __webpack_public_path__ + "static/media/curve.5e610277.png";